module.exports = __webpack_public_path__ + "static/img/theader.070228c1.png";